﻿import { getRootUrl, getBuildVersion } from "./context";
import { addScriptAsync } from "./addScript";

const nonce = document.currentScript?.nonce;

let scriptLoadedPromise = null;

export async function loadCodeMirror6Async(nonce) {
	scriptLoadedPromise ??= addScriptAsync({ src: `${getRootUrl()}/js/codemirror6-bundle.min.js?v=${encodeURIComponent(getBuildVersion())}`, nonce });
	await scriptLoadedPromise;
	return window.CodeMirror6;
}

export async function initTextEditors(context, selector = ".js-codemirror[data-cm-mode]") {
	context ??= document;
	if (context.querySelector(selector)) {
		const cm = await loadCodeMirror6Async(nonce);
		context.querySelectorAll(selector).forEach(elt => {
			cm.initTextFileEditor(elt, { submitToSave: true });
		});
	}
}